import axiosClient from './axiosClient';


export const addReservation = (reservation) => {
	return axiosClient.post('/reservations', reservation);
}
